import React, {
  useState
} from "react";

import axios from "axios";

import AchievementCard from "./AchievementCard";

import ClaimModal from "./ClaimModal";

const AchievementGrid = ({

  achievements = [],

  refreshProfile,

  email

}) => {

  const [

    selectedBadge,

    setSelectedBadge

  ] = useState(null);

  const [

    loading,

    setLoading

  ] = useState(false);

  /* ==========================
      CLAIM
  ========================== */

  const handleClaim = async (

    badgeId

  ) => {

    try {

      setLoading(true);

      await axios.patch(

        "/api/achievement/claim",

        {

          email,

          badgeId

        }

      );

      const badge =

        achievements.find(

          item =>

            item.badgeId === badgeId

        );

      setSelectedBadge(

        badge

      );

      if (

        refreshProfile

      ) {

        await refreshProfile();

      }

    }

    catch (err) {

      console.error(err);

    }

    finally {

      setLoading(false);

    }

  };

  return (

    <>

      <div className="achievement-grid">

        {

          achievements.map(

            achievement => (

              <AchievementCard

                key={

                  achievement.badgeId

                }

                achievement={

                  achievement

                }

                onClaim={

                  handleClaim

                }

              />

            )

          )

        }

      </div>

      {

        selectedBadge &&

        (

          <ClaimModal

            achievement={

              selectedBadge

            }

            onClose={() =>

              setSelectedBadge(

                null

              )

            }

          />

        )

      }

    </>

  );

};

export default AchievementGrid;